import { getDistance } from "geolib";
import React, { Component, Fragment } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import heart from "../../../../assets/images/heart-blue-boundary.svg";
import call from "../../../../assets/images/icon-call.svg";
import likeSelected from "../../../../assets/images/icon-like-selected.svg";
import location from "../../../../assets/images/icon-location.svg";
import share from "../../../../assets/images/icon-share.svg";
import shield from "../../../../assets/images/icon-shield.svg";
import status from "../../../../assets/images/icon-status.svg";
import provider1 from "../../../../assets/images/img-provider1.svg";
import provider2 from "../../../../assets/images/img-provider2.svg";
import provider3 from "../../../../assets/images/img-provider3.svg";
import { Contact } from "../../../../components/UI/Alerts/ContactAlert/ContactAlert";
import Modal from "../../../../components/UI/Modal/Modal";
import { logFirebaseEvent } from "../../../../shared/utility";
import * as findProviderActions from "../../../../store/actions/";
import classes from "./FindProviderResultItem.module.css";

interface IParentProps {
  onClick: (
    provideId: string,
    npi: string,
    distance: number,
    postalCode: string,
    orgDistance: string,
  ) => void;
  provider: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    isNational:boolean;
    providerType: string;
    specialty: string[];
    isContracted: boolean;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    experienceScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    providerTypeId: number;
    specialtyId: number;
    distance: number;
    gender: string;
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    finderLabel: string;
    additionalLocationsCount: number;
  };
  style: {};
  params: {
    distance: number;
    longitude: string;
    latitude: string;
    postalCode: string;
    providerName: string;
    providerType: string;
    specialty: string;
    scoreHigherThan: number;
    scoreLowerThan: number;
    isContracted: boolean;
    contractStatus: string;
    isFavorite: boolean;
    gender: string;
    fetchCurrentLocation: boolean;
    location: boolean;
    limit: string;
    currentAttempt: number;
    extendedDistance: number;
  };
  unFavoritedProvider: boolean;
  favoritedProvider: boolean;
}
interface IStateFromProps {
  latitude: number;
  longitude: number;
}
interface IDispatchFromProps {
  onFavoriteProvider: (
    providerId: number,
    npi: string,
    postalCode: string
  ) => void;
  onUnfavoriteProvider: (favoriteId: string) => void;
  onResetUnFavoriteProvider: () => void;
  onResetFavoriteProvider: () => void;
  onFetchCurrentLocation: () => void;
  onResetCurrentLocation: () => void;
}

type Props = IParentProps & IStateFromProps & IDispatchFromProps;

class FindProviderResultItem extends Component<Props> {
  state = {
    connect: false,
    favorite: this.props.provider.isFavorite,
    distance: 0,
    latitude: 0,
    longitude: 0,
  };
  shareHandler = (provider) => {
    let mailContent = "Subject=Provider Details&";
    mailContent += "body=";
    if (provider && this.state.latitude !== 0 && this.state.longitude !== 0) {
      mailContent += encodeURIComponent(
        `https://www.google.com/maps/dir/?api=1&origin=${this.state.latitude} ${this.state.longitude}&destination=${provider["latitude"]} ${provider["longitude"]}&travelmode=driving`
      );
    } else if (provider && this.props.params.postalCode) {
      mailContent += encodeURIComponent(
        `https://www.google.com/maps/dir/?api=1&origin=${this.props.params.postalCode}&destination=${provider["latitude"]} ${provider["longitude"]}&travelmode=driving`
      );
    } else {
      mailContent += encodeURIComponent(
        `https://www.google.com/maps/dir/?api=1&origin=0 0&destination=${provider["latitude"]} ${provider["longitude"]}&travelmode=driving`
      );
    }
    window.location.href = `mailto:?${mailContent}`;
    logFirebaseEvent("ShareButtonPressed");
  };

  contactHandler = () => {
    this.setState({ connect: true });
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  favoriteHandler = (providerId, npi, postalCode) => {
    this.props.onFavoriteProvider(providerId, npi, postalCode);
    this.setState({ favorite: true });
  };
  notFavoriteHandler = (favoriteId) => {
    if (favoriteId) {
      this.props.onUnfavoriteProvider(favoriteId);
    }
    this.setState({ favorite: false });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.latitude &&
      this.props.longitude &&
      (this.props.latitude !== prevProps.latitude ||
        this.props.longitude !== prevProps.longitude)
    ) {
      const distance =
        getDistance(
          {
            latitude: this.props.latitude,
            longitude: this.props.longitude,
          },
          {
            latitude: this.props.provider.latitude,
            longitude: this.props.provider.longitude,
          }
        ) * 0.000621371;
      this.setState({ distance: distance });
      this.setState({ latitude: this.props.latitude });
      this.setState({ longitude: this.props.longitude });
    }
    if (
      (prevProps.unFavoritedProvider === false &&
        this.props.unFavoritedProvider === true) ||
      (prevProps.favoritedProvider === false &&
        this.props.favoritedProvider === true)
    ) {
      this.props.onResetUnFavoriteProvider();
      this.props.onResetFavoriteProvider();
    }
  }
  componentDidMount() {
    this.props.onResetCurrentLocation();
    this.props.onFetchCurrentLocation();
  }
  render() {
    const { onClick, style, provider } = { ...this.props };
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    let connectAlert: any;
    if (this.state.connect) {
      connectAlert = (
        <Modal
          show={this.state.connect}
          childComp={
            <Contact
              modalClosed={this.connectedHandler}
              contactNumber={provider.phoneNumber}
            />
          }
          style={modalContact}
        ></Modal>
      );
    }
    let scoreDisplay: any;
    let mainInfo: any;
    mainInfo = (
      <div>
        <div className={classes.cardDetails}>
          <div
            onClick={() =>
              onClick(
                provider.providerId,
                provider.npi,
                provider.distance,
                provider.postalCode,
                provider.orgDistance,
              )
            }
          >
            <h4 className={classes.cardTitle}>
              {provider.providerName ? provider.providerName : "N/A"}
            </h4>
            <span className={classes.cardSubTitle}>
              {provider.providerType ? provider.providerType : "N/A"}
            </span>
            <div className={classes.cardCat}>
              <span className={classes.cardSubTitle}>
                {provider.specialty.length > 0 ? provider.specialty[0] : "N/A"}
              </span>
              <span className={classes.subTitleCount}>
                {provider.specialty.length - 1 !== 0 &&
                  `+${provider.specialty.length - 1}`}
              </span>
            </div>
          </div>
          <div className={classes.cardLike}>
            {this.state.favorite ? (
              <Image
                className="pointer"
                src={likeSelected}
                alt="favorite"
                onClick={() => this.notFavoriteHandler(provider.favoriteId)}
              />
            ) : (
              <Image
                className="pointer"
                src={heart}
                alt="notfavorite"
                onClick={() =>
                  this.favoriteHandler(
                    provider.providerId,
                    provider.npi,
                    provider.postalCode
                  )
                }
              />
            )}
          </div>
        </div>

        {/* <span className={classes.cardSubTitle}>
          {`${provider.providerType ? provider.providerType : "N/A"}-${
            provider.specialty ? provider.specialty : "N/A"
          }`}
        </span> */}
       {provider.isNational&& <span className={classes.nationalProvider}>
          National Provider
      </span>}
      </div>
    );
    if (provider.totalExperienceScore) {
      if (!provider.isContracted) {
        scoreDisplay = (
          <div className="cardStatus statusPending">
            <div className="statusImg">
              <Image src={status} alt="status" />
              <h4 className="statusCount">{provider.totalExperienceScore}</h4>
            </div>
            {/* <p>{provider.providerEntityType}</p> */}
            <p>{provider.finderLabel ?? provider.providerLabels[0]}</p>
          </div>
        );
      } else {
        scoreDisplay = (
          <div className="cardStatus statusSuccess">
            <Image src={shield} alt="shield" />
            {/* <p>{provider.providerEntityType}</p> */}
            <p>{provider.finderLabel ?? provider.providerLabels?.[0]}</p>
          </div>
        );
      }
    } else if (provider.experienceScore && provider.experienceScore[0].value) {
      if (!provider.isContracted) {
        scoreDisplay = (
          <div className="cardStatus statusPending">
            <div className="statusImg">
              <Image src={status} alt="status" />
              <h4 className="statusCount">
                {provider.experienceScore[0].value}
              </h4>
            </div>
            {/* <p>{provider.providerEntityType}</p> */}
            <p>{provider.finderLabel ?? provider.providerLabels?.[0]}</p>
          </div>
        );
      }else {
        scoreDisplay = (
          <div className="cardStatus statusSuccess">
            <Image src={shield} alt="shield" />
            {/* <p>{provider.providerEntityType}</p> */}
            <p>{provider.finderLabel ?? provider.providerLabels?.[0]}</p>
          </div>
        );
      }
    } else {
      scoreDisplay = (
        <div className="cardStatus">
          <p>{provider.finderLabel ?? provider.providerLabels?.[0]}</p>
        </div>
      );
    }
    
    let distanceCalculated: any;

    if (provider.distance && provider.distance !== 0) {
      distanceCalculated = provider.distance
        ? `${provider.distance.toFixed(1)} mi`
        : `N/A`;
    } else if (this.state.distance) {
      distanceCalculated = this.state.distance
        ? `${this.state.distance.toFixed(1)} mi`
        : `N/A`;
    } else {
      distanceCalculated = `N/A`;
    }

    let additionalLocationsCount:any;

    if(provider.additionalLocationsCount){
      additionalLocationsCount= '+'+provider.additionalLocationsCount
    }else{
      additionalLocationsCount = null;
    }

    let providerMedicare: any;
    providerMedicare = this.providerMedicareSelection(
      provider,
      providerMedicare
    );
    let providerImage: any;
    if (provider.providerEntityType.toLowerCase() === "individual") {
      providerImage = <Image src={provider1} alt="provider" />;
    } else if (provider.providerEntityType.toLowerCase() === "organization") {
      providerImage = <Image src={provider2} alt="provider" />;
    } else {
      providerImage = <Image src={provider3} alt="provider" />;
    }
    return (
      <Fragment>
        {connectAlert}
        <div className="cardSection" style={style}>
          <ul>
            <li>
              <div className={classes.cardsInfo}>
                <div className={classes.oval}>{providerImage}</div>
                {mainInfo}
                <div className={classes.cardLinks}>
                {provider.isNational?undefined:
                <div className={classes.cardLink}>
                    <Image src={location} alt="location" />
                    <span>{distanceCalculated}</span>
                    <span>{additionalLocationsCount}</span>
                  </div>}

                  {providerMedicare}

                  <div
                    className={classes.cardLink}
                    onClick={this.contactHandler}
                  >
                    <Image src={call} alt="call" className="pointer" />
                  </div>
                  <div
                    className={classes.cardLink}
                    onClick={() => this.shareHandler(provider)}
                  >
                    <Image src={share} alt="share" className="pointer" />
                  </div>
                </div>
              </div>
              {scoreDisplay}
              <div className="clear"></div>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }

  providerMedicareSelection = (
    provider: {
      providerId: string;
      providerName: string;
      providerEntityType: string;
      providerLabels: string[];
      longitude: number;
      latitude: number;
      address: string;
      city: string;
      state: string;
      hospitalName: string;
      postalCode: string;
      phoneNumber: string;
      providerType: string;
      specialty: string[];
      isContracted: boolean;
      favoriteId: string;
      isFavorite: boolean;
      totalExperienceScore: number;
      experienceScore: { label: string; value: number }[];
      quantrosScores: {
        category: string;
        scores: { name: string; order: number; score: number }[];
      }[];
      providerTypeId: number;
      specialtyId: number;
      distance: number;
      gender: string;
      medicareValue: number;
      npi: string;
      orgDistance: string;
      orgPostalCode: string;
      finderLabel: string;
    },
    providerMedicare: any
  ) => {
    if (provider.medicareValue === 0) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 1) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 2) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 3) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 4) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 5) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
        </div>
      );
    } else {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
        </div>
      );
    }
    return providerMedicare;
  };
}
const mapStateToProps = (state: any) => ({
  params: state.searchURL.params,
  unFavoritedProvider: state.favoriteProvider.unFavoritedProvider,
  favoritedProvider: state.favoriteProvider.favoritedProvider,
  latitude: state.fetchCurrentLocation.latitude,
  longitude: state.fetchCurrentLocation.longitude,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFavoriteProvider: (providerId, npi, postalCode) =>
    dispatch(findProviderActions.favoriteProvider(providerId, npi, postalCode)),
  onUnfavoriteProvider: (favoriteId) =>
    dispatch(findProviderActions.unfavoriteProvider(favoriteId)),
  onResetUnFavoriteProvider: () =>
    dispatch(findProviderActions.resetUnFavoriteProvider()),
  onResetFavoriteProvider: () =>
    dispatch(findProviderActions.resetFavoriteProvider()),
  onFetchCurrentLocation: () =>
    dispatch(findProviderActions.fetchCurrentLocation()),
  onResetCurrentLocation: () =>
    dispatch(findProviderActions.resetCurrentLocation()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindProviderResultItem);
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FindProviderResultItem));
